export default __webpack_public_path__ + "static/bombs-9fcb3ba5d7197cdfdff9fff46a97358d.png";